import { forwardRef, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GenericAutocompleteComponent } from "./generic-autocomplete.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatInputModule } from "@angular/material/input";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";

@NgModule({
  declarations: [GenericAutocompleteComponent],
  imports: [CommonModule, MatFormFieldModule, MatAutocompleteModule, MatInputModule, ReactiveFormsModule],
  exports: [GenericAutocompleteComponent],
})
export class AutocompleteGenericoModule {}
